import * as type from './type'
import { get, post } from '../../../../util/api'
import { selectLoginData } from './selector'
import { loadGlobals } from '../../../globals/state/action'
import { ERROR_PASSWORD_MUST_BE_NEW, ERROR_PASSWORD_NOT_IDENTICAL, ERROR_PASSWORD_NOT_SECURE } from './const'

export const changeLoginData = (name, value) => ({
    type: type.CHANGE_LOGIN_DATA,
    payload: {
        name,
        value,
    },
})

export const loginRequest = () => ({
    type: type.LOGIN_REQUEST,
})

export const loginSuccess = (user) => ({
    type: type.LOGIN_SUCCESS,
    payload: {
        user,
    },
})

export const loginError = (error) => ({
    type: type.LOGIN_ERROR,
    payload: {
        error,
    },
})

export const loginPasswordResetRequired = (error) => ({
    type: type.LOGIN_PASSWORD_RESET_REQUIRED,
    payload: {
        error,
    },
})


export const login = () => (dispatch, getState) => {
    const request = selectLoginData(getState())
    dispatch(loginRequest())

    post('/api/security/login', request)
        .then(user => {
            dispatch(loadGlobals())
        })
        .catch(error => {
            if (error.exception === 'PasswordResetRequiredException') {
                dispatch(loginPasswordResetRequired(error))
            } else {
                dispatch(loginError(error))
            }
        })
}

export const checkLoginStatus = () => (dispatch) => {
    get('/api/security/check-employee-login-status')
        .then(user => {
            dispatch(loginSuccess(user))
        })
        .catch(error => {

        })
}


export const logoutSuccess = () => ({
    type: type.LOGOUT_SUCCESS,
})


export const logout = () => (dispatch) => {
    get('/api/security/logout')
        .then(() => {
            dispatch(logoutSuccess())
        })
        .catch(error => {

        })
}

export const changePasswordRequest = () => ({
    type: type.CHANGE_PASSWORD_REQUEST,
})

export const changePasswordSuccess = () => ({
    type: type.CHANGE_PASSWORD_SUCCESS,
})

export const changePasswordError = (error) => ({
    type: type.CHANGE_PASSWORD_ERROR,
    payload: {
        error,
    },
})

export const isPasswordStrong = (password) => {
    if (!password) {
        return false
    }
    if (password.length < 8) {
        return false
    }
    return /\d/.test(password) && /[a-z]/.test(password) && /[A-Z]/.test(password)
}

export const changePassword = () => (dispatch, getState) => {
    const state = getState()
    const { email, password, newPassword, newPasswordRepeat } = selectLoginData(state)

    if (!email || !password || !newPassword || !newPasswordRepeat) {
        return
    }

    if (newPassword !== newPasswordRepeat) {
        return dispatch(changePasswordError(ERROR_PASSWORD_NOT_IDENTICAL))
    }

    if (newPassword === password) {
        return dispatch(changePasswordError(ERROR_PASSWORD_MUST_BE_NEW))
    }

    if (!isPasswordStrong(newPassword)) {
        return dispatch(changePasswordError(ERROR_PASSWORD_NOT_SECURE))
    }

    dispatch(changePasswordRequest())


    post('/api/security/change-password-with-old-password', {
        email,
        password,
        newPassword,
    })
        .then(user => {
            dispatch(loadGlobals())
        })
        .catch(error => {
            dispatch(loginError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/security/state/auth/action.js